button(data-title=title, class=classes, data-hook=name).btn-round.pure-button
  i(class=icon)
